import PlayBox from "./PlayBox";
import Thumbnail from "./Thumbnails";
import { Songcard } from "@/types";
import {
  Button,
  Card,
  CardBody,
  Center,
  Container,
  Stack,
  useColorMode,
} from "@chakra-ui/react";
import Link from "next/link";

interface CardProps {
  holdUUID: string;
  card: Songcard;
}

const CollectorCard = ({ card, holdUUID }: CardProps) => {
  const { colorMode } = useColorMode();

  const backgroundColor = colorMode === "light" ? "light.100" : "black";

  return (
    <>
      <Center>
        <Card
          maxW="xs"
          align="center"
          bgColor={backgroundColor}
          variant="outline"
          borderRadius={15}
        >
          <CardBody maxW={350}>
            <Center>
              <Thumbnail
                ext_file={card.ext_file}
                comp_file={card.comp_file}
                image={card.image}
              />
            </Center>
            <Stack mt="6" mb="0" spacing="3">
              <PlayBox card={card} />
              {holdUUID && (
                <Center mt={5}>
                  <Link href={`/open-card/${holdUUID}`}>
                    <Button variant={"outline"}>Open Card</Button>
                  </Link>
                </Center>
              )}
              <Container ml={0}></Container>
            </Stack>
            <Center></Center>
          </CardBody>
        </Card>
      </Center>
      <br />
    </>
  );
};

export default CollectorCard;
